import React from "react";
import logo from "../assets/images/headerimage.png"; // adjust path if needed
import bellIcon from "../assets/Icons/bell.png"; // adjust path to your bell image
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between h-18 px-6 bg-[#121212] max-[767px]:pl-20">
      {/* Logo */}
      <img
        src={logo}
        alt="Header Logo"
        className="h-8 w-auto object-contain mt-4 mb-4 cursor-pointer"
        onClick={() => navigate("/feed")}
      />

      {/* Bell Icon */}
      <button className="p-2">
        <img
          src={bellIcon}
          alt="Notifications"
          className="h-6 w-6 object-contain cursor-pointer"
          onClick={() => navigate("/notifications")}
        />
      </button>
    </div>
  );
};

export default Header;
